module.exports = __webpack_public_path__ + "static/media/emika1.320e9d66.jpg";